import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "space-y-6 py-9" }
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "text-sm text-gray-400"
}
const _hoisted_5 = { class: "flex justify-end gap-4" }
const _hoisted_6 = { class: "space-y-2 bg-gray-50 px-6 py-4" }
const _hoisted_7 = { class: "w-16 text-sm text-gray-500" }
const _hoisted_8 = { class: "flex-1 text-sm" }
const _hoisted_9 = { class: "w-40 text-sm text-gray-700" }

import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';

import JsonUpload from '../components/JsonUpload.vue';
import CalculationDeleteButton from '../components/CalculationDeleteButton.vue';
import CalculationCopyButton from '../components/CalculationCopyButton.vue';

import { useSearchCalculations } from '../composables/useSearchCalculations';
import { useCalculationFileHandler } from '../composables/useCalculationFileHandler';
import { useUserStore } from '../store/user';

import type { Calculation } from '../utils/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationsView',
  setup(__props) {

const route = useRoute();

const { search, searchedCalculations } = useSearchCalculations(Number(route.params.calculatorId));

const { isLoading, addCalculationFromFile } = useCalculationFileHandler();

const userStore = useUserStore();

const canCopy = computed(() => {
  const accountType = userStore.user?.account_type;

  return accountType === 'admin' || accountType === 'engineer' || accountType === 'seller';
});

const expandedRows = ref<Record<string, boolean>>({});

function toggleExpansion(data: Calculation) {
  if (data.id === null) return;

  const key = String(data.id);

  if (expandedRows.value[key]) {
    const { [key]: _removed, ...rest } = expandedRows.value;
    expandedRows.value = rest;
  } else {
    expandedRows.value = { ...expandedRows.value, [key]: true };
  }
}

function ownerName(owner: Calculation['owner']): string {
  if (!owner) return '—';

  return `${owner.first_name} ${owner.last_name}`.trim() || '—';
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "mr-auto font-lora text-3xl text-gray-900" }, "Lista moich kalkulacji", -1)),
      _createVNode(_unref(IconField), { class: "w-[430px]" }, {
        default: _withCtx(() => [
          _createVNode(_unref(InputIcon), { class: "pi pi-search" }),
          _createVNode(_unref(InputText), {
            class: "w-[430px]",
            modelValue: _unref(search),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(search) ? (search).value = $event : null)),
            placeholder: "Szukaj"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(JsonUpload, {
        chooseLabel: "Dodaj z pliku",
        isLoading: _unref(isLoading),
        onUpdate: _unref(addCalculationFromFile)
      }, null, 8, ["isLoading", "onUpdate"])
    ]),
    _createVNode(_unref(DataTable), {
      class: "overflow-hidden rounded-xl border border-gray-200 [&__.p-row-odd]:bg-gray-50",
      value: _unref(searchedCalculations),
      expandedRows: expandedRows.value,
      "onUpdate:expandedRows": _cache[1] || (_cache[1] = ($event: any) => ((expandedRows).value = $event)),
      dataKey: "id",
      rowClass: (data) => [{ '!bg-red-100': data.outdated || data.id === null }],
      removableSort: "",
      tableStyle: "min-width: 50rem"
    }, {
      expansion: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.data.calculation_children, (child) => {
            return (_openBlock(), _createElementBlock("div", {
              key: child.id,
              class: "flex items-center gap-4 rounded-md border border-gray-200 bg-white px-4 py-2"
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(child.id), 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(child.name), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(ownerName(child.owner)), 1),
              _createVNode(_component_RouterLink, {
                to: `/${_ctx.$route.params.calculatorId}/client/${child.client_uuid}/calculation/${child.uuid}`
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    class: "!p-2",
                    size: "small",
                    severity: "secondary",
                    outlined: ""
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createElementVNode("i", { class: "pi pi-pen-to-square" }, null, -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["to"]),
              (child.id)
                ? (_openBlock(), _createBlock(CalculationDeleteButton, {
                    key: 0,
                    calculationId: child.id
                  }, null, 8, ["calculationId"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          field: "id",
          header: "Id",
          sortable: "",
          style: {"width":"5%"}
        }),
        _createVNode(_unref(Column), {
          field: "name",
          header: "Nazwa",
          sortable: "",
          style: {"width":"30%"}
        }),
        _createVNode(_unref(Column), {
          header: "Klient",
          style: {"width":"25%"}
        }, {
          body: _withCtx(({ data }: { data: Calculation & { clientName: string } }) => [
            _createTextVNode(_toDisplayString(data.clientName), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Kopie",
          style: {"width":"8%"}
        }, {
          body: _withCtx(({ data }: { data: Calculation }) => [
            (data.calculation_children && data.calculation_children.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "inline-flex items-center gap-1 text-sm text-gray-700 hover:text-gray-900",
                  onClick: ($event: any) => (toggleExpansion(data))
                }, [
                  _createElementVNode("span", null, _toDisplayString(data.calculation_children.length), 1),
                  _createElementVNode("i", {
                    class: _normalizeClass([
                'pi text-xs',
                data.id !== null && expandedRows.value[String(data.id)]
                  ? 'pi-chevron-up'
                  : 'pi-chevron-down',
              ])
                  }, null, 2)
                ], 8, _hoisted_3))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, "0"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Stworzył",
          style: {"width":"15%"}
        }, {
          body: _withCtx(({ data }: { data: Calculation }) => [
            _createTextVNode(_toDisplayString(ownerName(data.owner)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "",
          style: {"width":"17%"}
        }, {
          body: _withCtx(({ data }: { data: Calculation }) => [
            _createElementVNode("div", _hoisted_5, [
              (canCopy.value && data.id)
                ? (_openBlock(), _createBlock(CalculationCopyButton, {
                    key: 0,
                    calculationId: data.id
                  }, null, 8, ["calculationId"]))
                : _createCommentVNode("", true),
              _createVNode(_component_RouterLink, {
                to: `/${_ctx.$route.params.calculatorId}/client/${data.client_uuid}/calculation/${data.uuid}`
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    class: "!p-2",
                    size: "small",
                    severity: "secondary",
                    outlined: ""
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createElementVNode("i", { class: "pi pi-pen-to-square" }, null, -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["to"]),
              (data.id)
                ? (_openBlock(), _createBlock(CalculationDeleteButton, {
                    key: 1,
                    calculationId: data.id
                  }, null, 8, ["calculationId"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "expandedRows", "rowClass"])
  ]))
}
}

})